export const appCategories = [
  { value: "all", label: "All Apps" },
  { value: "my-apps", label: "My Apps" },
  { value: "pending", label: "Pending" }
];